import React from "react";
import { Button } from "reactstrap";
import Profile from "../../../../assets/images/profile.png";
import Cross from "../../../../assets/images/verboden/cross.png";
import { removeUser } from "../../../shared/utils/index";
import { withSocket } from "../../../../socket/context";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import BlueCross from "../../../../assets/images/verboden/blue-cross.png";
import PurpleCross from "../../../../assets/images/verboden/purple-cross.png";

const QuaterBack = (props) => {
  const quaterBack = props.quaterBack;
  const roomData = props.roomData;
  const cruntteam = props?.roomData?.game_state?.current_team;
  const quaterBackText = props.qbText ? props.qbText : "Quarterback";

  return (
    <div className="player-info text-center">
      <div className="position-relative w-100">
        <h4 className="text-orange">
          {quaterBackText}{" "}
          <Button
            onClick={() => removeUser(roomData, quaterBack)}
            color="themePink"
          >
            <i className="fas fa-times" />
          </Button>
        </h4>
        {quaterBack && (
          <>
            <img src={quaterBack.profile_image} className="profile-img" />
            <h2 className="text text-lightBlue">{quaterBack.display_name}</h2>
          </>
        )}
      </div>
    </div>
  );
};

export default compose(withRouter, withSocket, connect(null, null))(QuaterBack);
